/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:95333742-00f7-492b-80d0-be1097829f25",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_RoFhgXrrb",
    "aws_user_pools_web_client_id": "3i0f82o6d92gac869h8estdqf2",
    "oauth": {},
    "aws_content_delivery_bucket": "cost-admin-console-20190806010507-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://cost-admin-console-20190806010507-hostingbucket-prod.s3-website-eu-west-1.amazonaws.com",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Countries-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "Fees-prod",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "project-images-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "countrycost",
            "endpoint": "https://kg85lp0f5f.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
